import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ColumnModel, IValueChanged, ODataModel, TableModel, isDefined } from '@evorait/pace-core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-data-maintenance-sysconfig-expandable',
    templateUrl: './data-maintenance-sysconfig-expandable.component.html',
    styleUrls: ['./data-maintenance-sysconfig-expandable.component.scss'],
    standalone: false,
})
export class DataMaintenanceSysconfigExpandableComponent {
    @Input() public model: TableModel<ODataModel>;
    @Input() public technicalIdOrFunctionalLocationLabel: string;
    @Input() public formChildren: FormArray;
    @Input() public displayReasonText: boolean;
    @Input() public row: ODataModel;
    @Input() public columns: ColumnModel[];
    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    @Output()
    public modelValueChangedEvent = new EventEmitter<IValueChanged>();

    public rowClick(): void {
        this.model.selectedRow = this.row;
        this.isCollapsed = !this.isCollapsed;
    }

    public modelValueChanged(event: IValueChanged): void {
        this.modelValueChangedEvent.emit(event);
    }

    /**
     * Retrieves a nested value from `row` by dot-separated field path.
     *
     * @param field - Dot-separated path to the value (e.g. `'equiShortDesc' or 'sernr.value'`)
     * @returns
     */
    public get(field: string): string {
        let current: unknown = this.row;
        for (const key of field.split('.')) {
            current = isDefined(current) ? (current as Record<string, unknown>)[key] : undefined;
        }
        return typeof current === 'string' ? current : '';
    }
}
